// 根据域名配置主题
import './base.less';
export default {
	default: () => require('./default.less'),
};
